<template>
  <div>
     <!-- Delete Success Toast -->
    <transition name="fade-slide">
      <div v-if="showDeleteSuccess" class="delete-success-toast" role="status">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span>{{ deleteSuccessMessage }}</span>
      </div>
    </transition>
    <v-container fluid style="padding: 0 25px;">
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("_Product") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <v-card class="card2" style="margin-top: 10px;">
        <v-card-text style="margin-top: -15px;">
          <v-row style="display: flex; justify-content: space-between; padding: 0 2px;">
            <v-col cols="12" md="5" class="mt-1">
              <span style="font-weight: 500; font-size: 28px;">Product Group List</span>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2 mr-2">
              <!-- <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="field-search-productgroup"
                      :label="'Product Group Name'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-productgroup"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card> -->
              <v-row align="center" justify="end" style="gap: 20px;">
                <!-- Search Field -->
                <v-text-field
                  v-model="searchName"
                  placeholder="Product Group Name"
                  hide-details
                  variant="plain"
                  class="search-input"
                  density="comfortable"
                  @keydown.enter.prevent="triggerSearch"
                  @click:clear="clearSearch"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <!-- Add Button -->
                <button
                  id="button-add-productgroup"
                  type="button"
                  class="products-header-button"
                  @click="Add()"
                >
                  <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
                  <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
                </button>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="dialog"
          class="px-6 mt-3"
        >
          
          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>
         <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
          <template v-slot:item="{ item }">
            <tr class="pg-row">
              <td data-label="No." style="text-align: left">{{ item.number }}</td>
              <td data-label="Name">{{ item.name }}</td>
              <td data-label="Updated By" style="text-align: left">{{ item.updateBy }}</td>
              <td data-label="Updated Date" style="text-align: left">{{ item.updateDate }}</td>
              <td style="text-align: center; padding: 12px; font-weight: 600;">
                <div class="action-container">
                  <div class="action-group">
                    <!-- Edit Button -->
                    <v-btn
                      :id='"button-edit-productgroup"'
                      variant="text"
                      density="comfortable"
                      class="pg-mobile-action"
                      @click="Edit(item)"
                      icon
                    >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="22"
                          height="22"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                      <!-- <v-icon size="18">mdi-pencil-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip> -->
                    </v-btn>

                    <!-- Action Divider -->
                    <!-- <div class="action-divider"></div> -->

                    <!-- Delete Button -->
                    <v-btn
                      :id='"button-delete-productgroup"'
                      variant="text"
                      density="comfortable"
                      class="pg-mobile-action"
                      @click="openDeleteDialog(item)"
                      icon
                      :disabled="btnDisableDelete(item)"
                    >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="22"
                          height="19"
                        />
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                      <!-- <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip> -->
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>

        <!-- Delete Dialog -->
        <v-dialog v-model="showDeleteDialog" max-width="570">
          <v-card class="delete-dialog-card">
            <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
              <span class="dialog-title font-weight-bold">Delete Product Group</span>
              <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6 pb-4 px-4 body-text">
              Are you sure you want to delete this product group? This action
              cannot be undone.
            </v-card-text>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
              <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">Cancel</button type="button">
              <v-btn class="delete-confirm-btn" :loading="deleting" @click="confirmDelete">
                <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                <p style="color: #ffffff; font-size: 11px; font-weight: 500;">Delete</p>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "ProductGroup",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: {},
  mixins: [checkPermissionTwo],
  data: () => ({
    today: null,
    searchName: null,
    _searchDebounce: null,
    AddIntentGroup: false,
    EditIntentGroup: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    DDIntentSession: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    GroupIntent: {
      IntentGroupID: null,
      Name: null,
      IntentSession: null,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    showDeleteDialog: false,
    itemToDelete: null,
    deleting: false,
    showDeleteSuccess: false,
    deleteSuccessMessage: "",
    _deleteToastTimer: null,
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "left",
          sortable: false,
          width: "10%",
        },
        {
          title: "Product Group Name",
          value: "Name",
          align: "left",
          sortable: true,
          width: "35%",
        },
        {
          title: "Updated By",
          value: "CreateBy",
          align: "left",
          sortable: true,
          width: "15%",
        },
        {
          title: "Updated Date",
          value: "updateDate",
          align: "left",
          sortable: true,
          width: "15%",
        },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          width: "15%",
        },
      ];
    },
    rangeStart() {
      if (!this.searchTotalTable) return 0;
      return (this.options.page - 1) * this.options.itemsPerPage + 1;
    },
    rangeEnd() {
      if (!this.searchTotalTable) return 0;
      return Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable);
    },
    totalPages() {
      return this.searchTotalTable;
    },
    totalPagesPages() {
      return Math.max(1, Math.ceil(this.searchTotalTable / this.options.itemsPerPage));
    }
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchName() {
      this.debounceSearch();
    }
  },
  methods: {
    initDebounce() {
      if (!this._searchDebounce) {
        this._searchDebounce = this.debounce(() => {
          // only auto-search if user has typed at least 2 chars or cleared input
          if (!this.searchName || this.searchName.length >= 2) {
            this.options.page = 1;
            this.Get();
          }
        }, 400);
      }
    },
    debounceSearch() {
      this.initDebounce();
      this._searchDebounce();
    },
    triggerSearch() {
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchName = null;
      this.options.page = 1;
      this.Get();
    },
    // generic debounce helper
    debounce(fn, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
    Get() {
      let self = this;
      self.dialog = true;
      self.loading = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableProductGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.options.page = 1;
      self.Get();
    },
    Add() {
      let self = this;
      self.GroupIntent.IntentGroupID = null;
      self.GroupIntent.Name = null;
      self.GroupIntent.IntentSession = null;
      // self.AddIntentGroup = true;
      self.$router.push({
        name: "ProductDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "ProductDetail",
        query: {
          id: item.productGroupID,
        },
      });
    },
    openDeleteDialog(item) {
      this.itemToDelete = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.itemToDelete = null;
    },
    confirmDelete() {
      if (!this.itemToDelete || this.deleting) return;
      this.deleting = true;
      this.dialog = true;
      const id = this.itemToDelete.productGroupID;
      this.showDeleteDialog = false;
      this.$call.DeleteProductGroup(
        { ProductGroupID: id },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // this.$swal.fire({
            //   icon: "success",
            //   title: dataResponse.message,
            //   showConfirmButton: false,
            //   timer: 1500,
            // });
            // Adjust page if this was the last item on the current page
            const currentPage = this.options.page;
            const perPage = this.options.itemsPerPage;
            const newTotal = this.searchTotalTable - 1;
            const pageFirstIndex = (currentPage - 1) * perPage + 1;
            if (newTotal < pageFirstIndex && currentPage > 1) {
              this.options.page = currentPage - 1;
            } else {
              this.Get();
            }
            this.itemToDelete = null;
            // Show custom success toast
            this.deleteSuccessMessage = "Product group has been deleted !";
            this.showDeleteSuccess = true;
            clearTimeout(this._deleteToastTimer);
            this._deleteToastTimer = setTimeout(() => {
              this.showDeleteSuccess = false;
            }, 3000);
          } else if (dataResponse.status == 1) {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
              confirmButtonText: this.$t("gotIt"),
              confirmButtonColor: "#d33",
            });
          }
          this.deleting = false;
          this.dialog = false;
        },
        (errorResource) => {
          this.deleting = false;
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    GetDDIntentSession() {
      let self = this;
      self.dialog = true;
      self.$call.DDIntentSession(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDIntentSession = dataResponse.data;
          } else {
            self.DDIntentSession = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
    this.initDebounce();
  },
  beforeUnmount() {
    clearTimeout(this._deleteToastTimer);
  },
};
</script>
<style scoped>
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.search-input {
  max-width: 280px;
  background: #ffffff;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none !important;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
::v-deep.UploadFile .NoDragDrop button.v-btn {
  margin: 0px !important;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Action Divider */
/* .action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
  transition: background-color 0.2s ease;
} */
.action-group {
  justify-content: center;
}

/* .action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
} */

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

/* Delete dialog specific styling */
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000;
}
.body-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
}

.delete-success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #2ABF56 0%, #135928 100%) !important;
  color: #ffffff;
  padding: 10px 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 80px;
}
.fade-slide-enter-active, .fade-slide-leave-active { transition: all .25s ease; }
.fade-slide-enter-from { opacity: 0; transform: translate(-50%, -8px); }
.fade-slide-leave-to { opacity: 0; transform: translate(-50%, -8px); }

/* Custom table footer bar styling */
.table-footer-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px 12px 4px;
  font-size: 12px;
  color: #171717;
}
.footer-left .total-label {
  margin-left: 12px;
  font-weight: 500; 
}
.per-page-group {
  display: flex;
  align-items: center;
  gap: 14px; 
}
.items-select :deep(.v-field) { 
  border-radius: 14px;
  margin-right: 6px;
}
.small-select :deep(.v-field) {
  min-height: 30px;
  height: 36px;
  padding: 0 4px;
}
.small-select :deep(.v-field__input) { 
  min-height: 30px; 
}
.items-select :deep(.v-field__input),
.items-select :deep(.v-select__selection-text),
.items-select :deep(.v-list-item-title) {
  font-size: 14px !important;
}
.dropdown-icon { 
  width: 20px;
  height: 20px;
  transition: transform .2s ease;
  margin-right: 4px;
}
.small-select.v-select--active-menu .dropdown-icon { 
  transform: rotate(180deg);
}
.range-label { 
  color: #171717;
}
.nav-buttons { 
  display: flex; align-items: center;
 }
.nav-btn { 
  min-width: 32px !important;
  height: 32px !important;
 }
.nav-btn :deep(.v-btn__content) { 
  line-height: 1; 
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  padding: 11px 8px;
  gap: 6px;
  margin-right: 16px;
}
/* .nav-btn:disabled { 
  opacity: 0.3; 
} */
@media (max-width: 1023px) {
  .table-overview { padding: 0 8px; }
  :deep(.v-data-table-header th) { padding: 0.75rem !important; }
  :deep(.v-data-table tbody td) { padding: 0.75rem !important; }
}

@media (max-width: 797px) {
  :deep(.v-data-table thead) { display: none; }
  :deep(.v-data-table tbody tr) {
    display: block;
    background: #ffffff;
    margin: 0 0 14px 0;
    border: 1px solid #E5E5E5;
    border-radius: 14px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.06);
    overflow: hidden;
  }
  :deep(.v-data-table tbody tr td) {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 14px !important;
    font-size: 12px !important;
    border: none !important;
    border-bottom: 1px solid #F1F1F1 !important;
  }
  :deep(.v-data-table tbody tr td:last-child) { border-bottom: none !important; }
  :deep(.v-data-table tbody tr td::before) {
    content: attr(data-label);
    font-weight: 600;
    color: #171717;
    flex: 0 0 110px;
    text-align: left;
    font-size: 11px;
  }
  :deep(.v-data-table tbody tr td[data-label='Action']) {
    flex-direction: column;
    align-items: flex-start;
  }
  .action-container { justify-content: flex-start; }
  .action-group { display: flex; gap: 4px; }
  .range-label { display: none; }
  .per-page-group { flex-wrap: wrap; gap: 10px; }
  .table-footer-bar { flex-direction: column; align-items: flex-start; gap: 8px; }
  .pg-mobile-action { gap: 6px; }
  .pg-mobile-action .action-text { display: inline-block; font-size: 10px; font-weight: 500; }
  :deep(.v-data-table tbody tr td[data-label='Action']) { flex-direction: row; align-items: center; }
  :deep(.v-data-table tbody tr td[data-label='Action']::before) { display: none; }
}

@media (max-width: 479px) {
  :deep(.v-data-table tbody tr td) { padding: 6px 12px !important; font-size: 11px !important; }
  :deep(.v-data-table tbody tr td::before) { flex-basis: 95px; font-size: 10px; }
  .delete-success-toast { width: 90%; }
  .per-page-label { font-size: 11px; }
  .total-label { font-size: 11px; }
  .items-select :deep(.v-field__input) { font-size: 12px; }
  .pg-mobile-action { gap: 6px; }
  .pg-mobile-action .action-text { display: inline-block; font-size: 10px; font-weight: 500; }
  :deep(.v-data-table tbody tr td[data-label='Action']) { flex-direction: row; align-items: center; }
  :deep(.v-data-table tbody tr td[data-label='Action']::before) { display: none; }
}

@media (max-width: 359px) {
  :deep(.v-data-table tbody tr td) { padding: 6px 12px !important; font-size: 11px !important; }
  :deep(.v-data-table tbody tr td::before) { flex-basis: 95px; font-size: 10px; }
  .delete-success-toast { width: 90%; }
  .per-page-label { font-size: 11px; }
  .total-label { font-size: 11px; }
  .items-select :deep(.v-field__input) { font-size: 12px; }
  .pg-mobile-action { gap: 6px; }
  .pg-mobile-action .action-text { display: inline-block; font-size: 10px; font-weight: 500; }
  :deep(.v-data-table tbody tr td[data-label='Action']) { flex-direction: row; align-items: center; }
  :deep(.v-data-table tbody tr td[data-label='Action']::before) { display: none; }
}
</style>
